// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoices-container {
  padding: 20px;
  background-color: #f8f9fa;
}
.invoices-container .cancel-select-btn {
  padding: 8px 18px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.invoices-container input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--primary-color);
}
.invoices-container .checkbox-fade {
  opacity: 0;
  transform: scale(0.8);
}
.invoices-container .filter-group label {
  display: block;
  margin-bottom: 8px;
}
.invoices-container h2 {
  margin-bottom: 2rem;
  font-size: 28px;
  color: #2c3e50;
  text-align: center;
  font-weight: 600;
  position: relative;
}
.invoices-container h2::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);
  border-radius: 2px;
}
.invoices-container .no-invoice-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}
.invoices-container .invoices-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}
.invoices-container .invoices-header .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.invoices-container .invoices-header .header-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.invoices-container .invoices-header .header-buttons .send-email-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.invoices-container .invoices-header .header-buttons .filter-dropdown-wrapper {
  position: relative;
  z-index: 10;
}
.invoices-container .invoices-header .header-buttons .filter-dropdown-wrapper .filter-toggle-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
}
.invoices-container .invoice-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  margin-top: 1rem;
}
.invoices-container .invoice-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.invoices-container .invoice-card .header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f1f3f4;
}
.invoices-container .invoice-card .header h4 {
  margin: 0;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 700;
  letter-spacing: -0.3px;
}
.invoices-container .invoice-card .header .status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoices-container .invoice-card .header .status.cancelled {
  background: #ffe6e6;
  color: #dc3545;
}
.invoices-container .invoice-card .header .status.paid {
  background: #e8f5e8;
  color: #28a745;
}
.invoices-container .invoice-card .header .status.pending {
  background: #fff3cd;
  color: #ffc107;
}
.invoices-container .invoice-card .header .status.part-payment {
  background: #e7f3ff;
  color: #0066cc;
}
.invoices-container .invoice-card .updating-status {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.invoices-container .invoice-card .updating-status .status-update-btn {
  padding: 6px 12px;
  background: #17a2b8;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.invoices-container .invoice-card .updating-status .status-update-btn:hover {
  background: #138496;
  transform: translateY(-1px);
}
.invoices-container .invoice-card p {
  margin: 8px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
}
.invoices-container .invoice-card p strong {
  color: #495057;
  font-weight: 600;
}
.invoices-container .invoice-card .items {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f1f3f4;
}
.invoices-container .invoice-card .items > strong {
  display: block;
  margin-bottom: 0.5rem;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}
.invoices-container .invoice-card .items .item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 0.5rem;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px solid #f8f9fa;
  align-items: center;
}
.invoices-container .invoice-card .items .item:last-child {
  border-bottom: none;
}
.invoices-container .invoice-card .items .item div:first-child {
  color: #495057;
  font-weight: 500;
}
.invoices-container .invoice-card .items .item div:nth-child(2) {
  color: #6c757d;
  font-size: 12px;
  text-align: center;
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
}
.invoices-container .invoice-card .items .item div:last-child {
  color: #495057;
  font-weight: 600;
  text-align: right;
  font-size: 13px;
}
.invoices-container .invoice-card .invoice-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid #f1f3f4;
}
.invoices-container .invoice-card .invoice-actions button {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}
.invoices-container .invoice-card .invoice-actions button:first-child {
  background: #17a2b8;
  color: white;
}
.invoices-container .invoice-card .invoice-actions button:first-child:hover {
  background: #138496;
}
.invoices-container .invoice-card .invoice-actions button:last-child {
  background-color: #5cb85c;
  color: white;
}
.invoices-container .invoice-card .invoice-actions button:last-child:hover {
  background: #4cae4c;
}
.invoices-container .invoice-card .invoice-actions button.disabled-btn {
  background-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.invoices-container .invoice-card .invoice-actions button.disabled-btn:hover {
  background: #cccccc;
}
.invoices-container .invoice-card .invoice-actions .preview-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.invoices-container .invoice-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
  margin-top: 1rem;
}
.invoices-container .invoice-table thead {
  background-color: #f1f5f9;
}
.invoices-container .invoice-table thead th {
  padding: 16px 12px;
  text-align: left;
  color: #495057;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 2px solid #e9ecef;
}
.invoices-container .invoice-table tbody tr {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f1f3f4;
}
.invoices-container .invoice-table tbody tr:hover {
  background: #f8f9fa;
}
.invoices-container .invoice-table tbody tr:last-child {
  border-bottom: none;
}
.invoices-container .invoice-table tbody tr:nth-last-child(-n+3) .amount-dropdown .amount-details {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 2px;
  transform: translateY(5px);
  z-index: 1000;
}
.invoices-container .invoice-table tbody tr:nth-last-child(-n+3) .amount-dropdown:hover .amount-details {
  transform: translateY(10px);
}
.invoices-container .invoice-table tbody tr:nth-last-child(-n+3) .amount-dropdown:hover .amount-header .dropdown-arrow {
  transform: rotate(-180deg);
}
.invoices-container .invoice-table tbody tr td {
  padding: 12px;
  font-size: 14px;
  color: #495057;
  vertical-align: top;
}
.invoices-container .invoice-table tbody tr td:last-child {
  white-space: nowrap;
  display: flex;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.cancelled {
  background: #ffe6e6;
  color: #dc3545;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.paid {
  background: #e8f5e8;
  color: #28a745;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.pending {
  background: #fff3cd;
  color: #ffc107;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.part-payment {
  background: #e7f3ff;
  color: #0066cc;
}
.invoices-container .invoice-table .item-list-square {
  margin: 0;
  padding-left: 16px;
}
.invoices-container .invoice-table .item-list-square li {
  margin-bottom: 4px;
  font-size: 13px;
  color: #6c757d;
}
.invoices-container .invoice-table button {
  margin-right: 6px;
  padding: 8px 18px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.invoices-container .invoice-table button:first-child {
  background: #17a2b8;
  color: white;
}
.invoices-container .invoice-table button:first-child:hover {
  background: #138496;
  opacity: 0.9;
}
.invoices-container .invoice-table button:nth-child(2) {
  background: #6c757d;
  color: white;
}
.invoices-container .invoice-table button:nth-child(2):hover {
  background: #6c757d;
}
.invoices-container .invoice-table button:last-child {
  background: #28a745;
  color: white;
}
.invoices-container .invoice-table button:last-child:hover {
  background: #218838;
}
.invoices-container .invoice-table button:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
}
.invoices-container .invoice-table .preview-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.invoices-container .invoice-card .header input[type=checkbox] {
  margin-left: auto;
  margin-right: 8px; /* Adjust for rightmost positioning */
}
.invoices-container .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}
.invoices-container .modal-overlay .send-email-modal {
  background: #ffffff;
  border-radius: 12px;
  padding: 0;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.2s ease;
}
.invoices-container .modal-overlay .send-email-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e9ecef;
}
.invoices-container .modal-overlay .send-email-modal .modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #2c3e50;
  font-weight: 600;
}
.invoices-container .modal-overlay .send-email-modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.invoices-container .modal-overlay .send-email-modal .modal-header .close-btn:hover {
  background: #f8f9fa;
  color: #495057;
}
.invoices-container .modal-overlay .send-email-modal .modal-body {
  padding: 1.5rem;
}
.invoices-container .modal-overlay .send-email-modal .modal-body p {
  margin: 0 0 1.5rem 0;
  color: #6c757d;
  font-size: 16px;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn {
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.paid {
  background: #e8f5e8;
  color: #28a745;
  border: 2px solid #28a745;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.paid:hover {
  background: #28a745;
  color: white;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.cancelled {
  background: #ffe6e6;
  color: #dc3545;
  border: 2px solid #dc3545;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.cancelled:hover {
  background: #dc3545;
  color: white;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.pending {
  background: #fff3cd;
  color: #ffc107;
  border: 2px solid #ffc107;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.pending:hover {
  background: #ffc107;
  color: white;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.part-payment {
  background: #e7f3ff;
  color: #0066cc;
  border: 2px solid #0066cc;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.part-payment:hover {
  background: #0066cc;
  color: white;
}
.invoices-container .loader {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  font-size: 16px;
}
.invoices-container .loader::after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: 10px;
}
@media (max-width: 768px) {
  .invoices-container {
    padding: 1rem;
  }
  .invoices-container .invoices-header {
    flex-direction: column;
    gap: 1rem;
  }
  .invoices-container .invoices-header .view-toggle-wrapper {
    order: 2;
    align-self: flex-start;
  }
  .invoices-container .invoices-header .header-buttons {
    order: 1;
    align-self: flex-end;
    flex-direction: column;
    width: 100%;
  }
  .invoices-container .invoices-header .header-buttons .send-email-btn,
  .invoices-container .invoices-header .header-buttons .filter-toggle-btn {
    width: 100%;
  }
  .invoices-container .invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box {
    width: 280px;
    right: 0;
    left: auto;
  }
  .invoices-container .invoice-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .invoices-container .invoice-card {
    padding: 1rem;
  }
  .invoices-container .invoice-card .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .invoices-container .invoice-card .header .status {
    align-self: flex-end;
  }
  .invoices-container .invoice-card .items .item {
    grid-template-columns: 1fr;
    gap: 0.25rem;
    text-align: left;
  }
  .invoices-container .invoice-card .items .item div:nth-child(2),
  .invoices-container .invoice-card .items .item div:last-child {
    text-align: left;
  }
  .invoices-container .invoice-table {
    font-size: 13px;
    margin-bottom: 60px;
  }
  .invoices-container .invoice-table thead th,
  .invoices-container .invoice-table tbody td {
    padding: 8px;
  }
  .invoices-container h2 {
    font-size: 24px;
  }
  .invoices-container .modal-overlay .send-email-modal {
    width: 95%;
    margin: 1rem;
  }
  .invoices-container .modal-overlay .send-email-modal .modal-body .status-options {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn {
    padding: 10px 12px;
    font-size: 12px;
  }
}

.amount-dropdown {
  position: relative;
  cursor: pointer;
}
.amount-dropdown .amount-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.amount-dropdown .amount-header strong {
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}
.amount-dropdown .amount-header .dropdown-arrow {
  font-size: 10px;
  color: #6c757d;
  transition: transform 0.2s ease;
}
.amount-dropdown .amount-details {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-5px);
  transition: all 0.2s ease;
  margin-top: 2px;
}
.amount-dropdown .amount-details .amount-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  font-size: 13px;
  border-bottom: 1px solid #f1f3f4;
}
.amount-dropdown .amount-details .amount-row:last-child {
  border-bottom: none;
}
.amount-dropdown .amount-details .amount-row.pending {
  background: #fff3cd;
  color: #856404;
  font-weight: 600;
}
.amount-dropdown .amount-details .amount-row span:first-child {
  color: #6c757d;
}
.amount-dropdown .amount-details .amount-row span:last-child {
  font-weight: 600;
  color: #495057;
}
.amount-dropdown:hover .amount-header {
  background: #e9ecef;
  border-color: #dee2e6;
}
.amount-dropdown:hover .amount-header .dropdown-arrow {
  transform: rotate(180deg);
}
.amount-dropdown:hover .amount-details {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.table-dropdown .amount-header {
  background: transparent;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
}
.table-dropdown .amount-header:hover {
  background: #f8f9fa;
}
.table-dropdown .amount-header span:first-child {
  font-weight: 600;
  color: #495057;
}
.table-dropdown .amount-details {
  min-width: 150px;
  left: -20px;
}

@media (max-width: 768px) {
  .amount-dropdown .amount-details {
    position: fixed;
    left: 10px;
    right: 10px;
    top: auto;
    bottom: 10px;
    border-radius: 8px;
    margin: 0;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 400;
}
.pagination-settings #invoicePerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #invoicePerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #invoicePerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #invoicePerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Invoices/Invoices.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;AACE;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;AAIE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;AAFJ;AAME;EACE,UAAA;EACA,qBAAA;AAJJ;AAQE;EACE,cAAA;EACA,kBAAA;AANJ;AASE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AASI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,0EAAA;EACA,kBAAA;AAPN;AAWE;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AATJ;AAaE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;AAXJ;AAaI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAXN;AAaM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAXR;AAaQ;EACE,eAAA;EACA,cAAA;AAXV;AAcQ;EACE,yBAAA;AAZV;AAeQ;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAbV;AAmBI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAjBN;AAmBM;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjBR;AA0BM;EACE,kBAAA;EACA,WAAA;AAxBR;AA0BQ;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAxBV;AA+BE;EACE,aAAA;EACA,SAAA;EACA,4DAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AA9BJ;AAiCI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA/BN;AAiCM;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AA/BR;AAkCM;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAhCR;AAkCQ;EACE,mBAAA;EACA,cAAA;AAhCV;AAmCQ;EACE,mBAAA;EACA,cAAA;AAjCV;AAoCQ;EACE,mBAAA;EACA,cAAA;AAlCV;AAqCQ;EACE,mBAAA;EACA,cAAA;AAnCV;AAwCI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAtCN;AAwCM;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAtCR;AAwCQ;EACE,mBAAA;EACA,2BAAA;AAtCV;AA2CI;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAzCN;AA2CM;EACE,cAAA;EACA,gBAAA;AAzCR;AA6CI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA3CN;AA6CM;EACE,cAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3CR;AA8CM;EACE,aAAA;EACA,kCAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AA5CR;AA8CQ;EACE,mBAAA;AA5CV;AA+CQ;EACE,cAAA;EACA,gBAAA;AA7CV;AAgDQ;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA9CV;AAiDQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA/CV;AAoDI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAlDN;AAoDM;EACE,SAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAlDR;AAoDQ;EACE,mBAAA;EACA,YAAA;AAlDV;AAoDU;EACE,mBAAA;AAlDZ;AAsDQ;EACE,yBAAA;EAEA,YAAA;AArDV;AAuDU;EACE,mBAAA;AArDZ;AAyDQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAvDV;AAyDU;EACE,mBAAA;AAvDZ;AA4DM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA1DR;AA+DE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;AA7DJ;AAiEI;EACE,yBAAA;AA/DN;AAiEM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA/DR;AAoEM;EACE,sCAAA;EACA,gCAAA;AAlER;AAoEQ;EACE,mBAAA;AAlEV;AAqEQ;EACE,mBAAA;AAnEV;AAyEY;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;AAvEd;AA2Ec;EACE,2BAAA;AAzEhB;AA4Ec;EACE,0BAAA;AA1EhB;AAgFQ;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA9EV;AAgFU;EACE,mBAAA;EACA,aAAA;AA9EZ;AAmFY;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAjFd;AAmFc;EACE,mBAAA;EACA,cAAA;AAjFhB;AAoFc;EACE,mBAAA;EACA,cAAA;AAlFhB;AAqFc;EACE,mBAAA;EACA,cAAA;AAnFhB;AAsFc;EACE,mBAAA;EACA,cAAA;AApFhB;AA4FI;EACE,SAAA;EACA,kBAAA;AA1FN;AA4FM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AA1FR;AA8FI;EAEE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7FN;AA+FM;EACE,mBAAA;EACA,YAAA;AA7FR;AA+FQ;EACE,mBAAA;EACA,YAAA;AA7FV;AAiGM;EACE,mBAAA;EACA,YAAA;AA/FR;AAiGQ;EACE,mBAAA;AA/FV;AAmGM;EACE,mBAAA;EACA,YAAA;AAjGR;AAmGQ;EACE,mBAAA;AAjGV;AAqGM;EACE,8BAAA;EACA,yBAAA;EACA,8BAAA;AAnGR;AAuGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AArGN;AAwGA;EACE,iBAAA;EACA,iBAAA,EAAA,qCAAA;AAtGF;AA2GE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;AAzGJ;AA2GI;EACE,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,4BAAA;AAzGN;AA2GM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAzGR;AA2GQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAzGV;AA4GQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AA1GV;AA4GU;EACE,mBAAA;EACA,cAAA;AA1GZ;AA+GM;EACE,eAAA;AA7GR;AA+GQ;EACE,oBAAA;EACA,cAAA;EACA,eAAA;AA7GV;AAgHQ;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AA9GV;AAgHU;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AA9GZ;AAgHY;EACE,2BAAA;EACA,0CAAA;AA9Gd;AAiHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA/Gd;AAiHc;EACE,mBAAA;EACA,YAAA;AA/GhB;AAmHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAjHd;AAmHc;EACE,mBAAA;EACA,YAAA;AAjHhB;AAqHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAnHd;AAqHc;EACE,mBAAA;EACA,YAAA;AAnHhB;AAuHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArHd;AAuHc;EACE,mBAAA;EACA,YAAA;AArHhB;AA+HE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA7HJ;AA+HI;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;AA7HN;AAkIE;EA/rBF;IAgsBI,aAAA;EA/HF;EAiIE;IACE,sBAAA;IACA,SAAA;EA/HJ;EAiII;IACE,QAAA;IACA,sBAAA;EA/HN;EAkII;IACE,QAAA;IACA,oBAAA;IACA,sBAAA;IACA,WAAA;EAhIN;EAkIM;;IAEE,WAAA;EAhIR;EAoIQ;IACE,YAAA;IACA,QAAA;IACA,UAAA;EAlIV;EAwIE;IACE,0BAAA;IACA,SAAA;EAtIJ;EAyIE;IACE,aAAA;EAvIJ;EAyII;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EAvIN;EAyIM;IACE,oBAAA;EAvIR;EA2II;IACE,0BAAA;IACA,YAAA;IACA,gBAAA;EAzIN;EA2IM;;IAEE,gBAAA;EAzIR;EA8IE;IACE,eAAA;IAEA,mBAAA;EA7IJ;EA+II;;IAEE,YAAA;EA7IN;EAiJE;IACE,eAAA;EA/IJ;EAmJI;IACE,UAAA;IACA,YAAA;EAjJN;EAoJQ;IACE,8BAAA;IACA,QAAA;EAlJV;EAoJU;IACE,kBAAA;IACA,eAAA;EAlJZ;AACF;;AA2JA;EACE,kBAAA;EACA,eAAA;AAxJF;AA0JE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAxJJ;AA0JI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAxJN;AA2JI;EACE,eAAA;EACA,cAAA;EACA,+BAAA;AAzJN;AA6JE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AA3JJ;AA6JI;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AA3JN;AA6JM;EACE,mBAAA;AA3JR;AA8JM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA5JR;AA+JM;EACE,cAAA;AA7JR;AAgKM;EACE,gBAAA;EACA,cAAA;AA9JR;AAoKI;EACE,mBAAA;EACA,qBAAA;AAlKN;AAoKM;EACE,yBAAA;AAlKR;AAsKI;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AApKN;;AA2KE;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAxKJ;AA0KI;EACE,mBAAA;AAxKN;AA2KI;EACE,gBAAA;EACA,cAAA;AAzKN;AA6KE;EACE,gBAAA;EACA,WAAA;AA3KJ;;AAgLA;EAEI;IACE,eAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;IACA,kBAAA;IACA,SAAA;EA9KJ;AACF;AAmLA;EACE;IACE,uBAAA;EAjLF;EAoLA;IACE,yBAAA;EAlLF;AACF;AAqLA;EACE;IACE,UAAA;IACA,4BAAA;EAnLF;EAsLA;IACE,UAAA;IACA,wBAAA;EApLF;AACF;AAuLA;EACE;IACE,UAAA;EArLF;EAwLA;IACE,UAAA;EAtLF;AACF;AAyLA;EACE;IACE,UAAA;IACA,qBAAA;EAvLF;EA0LA;IACE,UAAA;IACA,mBAAA;EAxLF;AACF;AA2LA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAzLF;AA4LE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA1LJ;AA8LE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AAlMJ;AAqMI;EACE,yBAAA;AAnMN;AAuMI;EACE,wDAAA;EACA,uBAAA;AArMN;AAyMI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAvMN","sourcesContent":[".invoices-container {\n  padding: 20px;\n  background-color: #f8f9fa;\n\n  .cancel-select-btn {\n  padding: 8px 18px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n\n}\n\n\n  input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: var(--primary-color);\n  }\n\n  // GSAP checkbox animations - minimal styling\n  .checkbox-fade {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n\n  .filter-group label {\n    display: block;\n    margin-bottom: 8px;\n  }\n\n  h2 {\n    margin-bottom: 2rem;\n    font-size: 28px;\n    color: #2c3e50;\n    text-align: center;\n    font-weight: 600;\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: -8px;\n      left: 50%;\n      transform: translateX(-50%);\n      width: 60px;\n      height: 3px;\n      background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);\n      border-radius: 2px;\n    }\n  }\n\n  .no-invoice-found {\n    text-align: center;\n    font-size: 1.1rem;\n    color: var(--text-color-medium);\n    padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n    background: var(--card-bg);\n    border-radius: 0.75rem;\n    border: 1px dashed var(--border-color);\n    box-shadow: 0 2px 5px var(--shadow-light);\n    margin-top: calc(var(--spacing-unit) * 2);\n    grid-column: 1 / -1;\n  }\n\n  // Header section with controls\n  .invoices-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    gap: 1rem;\n\n    .view-toggle-wrapper {\n      display: flex;\n      gap: 0.5rem;\n      align-items: center;\n\n      .view-toggle-btn {\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        padding: 0.3rem 0.6rem;\n        font-size: 0.85rem;\n        font-weight: 500;\n        background-color: transparent;\n        color: #444;\n        border: 1px solid var(--border-color);\n        border-radius: 6px;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        svg {\n          font-size: 1rem;\n          color: inherit;\n        }\n\n        &:hover {\n          background-color: #f3f4f6;\n        }\n\n        &.active {\n          background-color: #e5e7eb;\n          color: #222;\n          border-color: #cbd5e1;\n        }\n      }\n    }\n\n    // Header buttons container\n    .header-buttons {\n      display: flex;\n      gap: 0.5rem;\n      align-items: center;\n\n      .send-email-btn {\n        padding: 8px 18px;\n        background: var(--primary-color);\n        color: white;\n        border: none;\n        border-radius: 0.5rem;\n        cursor: pointer;\n        font-weight: 500;\n        transition: all 0.2s ease;\n\n        // &:hover {\n        //   background: #5a6fd8;\n        //   transform: translateY(-1px);\n        //   box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n        // }\n      }\n\n      .filter-dropdown-wrapper {\n        position: relative;\n        z-index: 10;\n\n        .filter-toggle-btn {\n          padding: 8px 18px;\n          background: var(--primary-color);\n          color: white;\n          border: none;\n          border-radius: 8px;\n          cursor: pointer;\n          font-weight: 500;\n        }\n    }\n  }\n}\n\n\n  .invoice-grid {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    margin-top: 1rem;\n  }\n\n  .invoice-card {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 1.5rem;\n    border: 1px solid #e9ecef;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n\n\n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      margin-bottom: 1rem;\n      padding-bottom: 1rem;\n      border-bottom: 1px solid #f1f3f4;\n\n      h4 {\n        margin: 0;\n        font-size: 18px;\n        color: #2c3e50;\n        font-weight: 700;\n        letter-spacing: -0.3px;\n      }\n\n      .status {\n        padding: 4px 12px;\n        border-radius: 20px;\n        font-size: 11px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n\n        &.cancelled {\n          background: #ffe6e6;\n          color: #dc3545;\n        }\n\n        &.paid {\n          background: #e8f5e8;\n          color: #28a745;\n        }\n\n        &.pending {\n          background: #fff3cd;\n          color: #ffc107;\n        }\n\n        &.part-payment {\n          background: #e7f3ff;\n          color: #0066cc;\n        }\n      }\n    }\n\n    .updating-status {\n      display: flex;\n      justify-content: flex-end;\n      margin-bottom: 1rem;\n\n      .status-update-btn {\n        padding: 6px 12px;\n        background: #17a2b8;\n        color: white;\n        border: none;\n        border-radius: 6px;\n        font-size: 12px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #138496;\n          transform: translateY(-1px);\n        }\n      }\n    }\n\n    p {\n      margin: 8px 0;\n      color: #6c757d;\n      font-size: 14px;\n      line-height: 1.4;\n\n      strong {\n        color: #495057;\n        font-weight: 600;\n      }\n    }\n\n    .items {\n      margin-top: 1rem;\n      padding-top: 1rem;\n      border-top: 1px solid #f1f3f4;\n\n      >strong {\n        display: block;\n        margin-bottom: 0.5rem;\n        color: #495057;\n        font-size: 14px;\n        font-weight: 600;\n      }\n\n      .item {\n        display: grid;\n        grid-template-columns: 2fr 1fr 1fr;\n        gap: 0.5rem;\n        padding: 8px 0;\n        font-size: 13px;\n        border-bottom: 1px solid #f8f9fa;\n        align-items: center;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        div:first-child {\n          color: #495057;\n          font-weight: 500;\n        }\n\n        div:nth-child(2) {\n          color: #6c757d;\n          font-size: 12px;\n          text-align: center;\n          background: #f8f9fa;\n          padding: 2px 6px;\n          border-radius: 4px;\n        }\n\n        div:last-child {\n          color: #495057;\n          font-weight: 600;\n          text-align: right;\n          font-size: 13px;\n        }\n      }\n    }\n\n    .invoice-actions {\n      display: flex;\n      gap: 8px;\n      margin-top: auto;\n      padding-top: 1rem;\n      border-top: 1px solid #f1f3f4;\n\n      button {\n        flex: 1;\n        padding: 8px 12px;\n        border: none;\n        border-radius: 6px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        font-size: 13px;\n\n        &:first-child {\n          background: #17a2b8;\n          color: white;\n\n          &:hover {\n            background: #138496;\n          }\n        }\n\n        &:last-child {\n          background-color: #5cb85c;\n          ;\n          color: white;\n\n          &:hover {\n            background: #4cae4c;\n          }\n        }\n\n        &.disabled-btn {\n          background-color: #cccccc;\n          cursor: not-allowed;\n          opacity: 0.6;\n\n          &:hover {\n            background: #cccccc;\n          }\n        }\n      }\n\n      .preview-btn {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n      }\n    }\n  }\n\n  .invoice-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: #ffffff;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    border: 1px solid #e9ecef;\n    margin-top: 1rem;\n    // ADDED: Space at bottom for dropdowns\n    //margin-bottom: 100px;\n\n    thead {\n      background-color: #f1f5f9;\n\n      th {\n        padding: 16px 12px;\n        text-align: left;\n        color: #495057;\n        font-weight: 600;\n        font-size: 14px;\n        border-bottom: 2px solid #e9ecef;\n      }\n    }\n\n    tbody {\n      tr {\n        transition: background-color 0.2s ease;\n        border-bottom: 1px solid #f1f3f4;\n\n        &:hover {\n          background: #f8f9fa;\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        // ADDED: Target last 3 rows for upward dropdowns\n        &:nth-last-child(-n+3) {\n          .amount-dropdown {\n            .amount-details {\n              top: auto;\n              bottom: 100%;\n              margin-top: 0;\n              margin-bottom: 2px;\n              transform: translateY(5px);\n              z-index: 1000;\n            }\n\n            &:hover {\n              .amount-details {\n                transform: translateY(10px);\n              }\n\n              .amount-header .dropdown-arrow {\n                transform: rotate(-180deg); // Flip arrow for upward dropdown\n              }\n            }\n          }\n        }\n\n        td {\n          padding: 12px;\n          font-size: 14px;\n          color: #495057;\n          vertical-align: top;\n\n          &:last-child {\n            white-space: nowrap;\n            display: flex;\n          }\n\n          // Status column styling\n          &:nth-child(2) {\n            .status {\n              display: inline-block;\n              padding: 4px 12px;\n              border-radius: 20px;\n              font-size: 11px;\n              font-weight: 700;\n              text-transform: uppercase;\n              letter-spacing: 0.5px;\n\n              &.cancelled {\n                background: #ffe6e6;\n                color: #dc3545;\n              }\n\n              &.paid {\n                background: #e8f5e8;\n                color: #28a745;\n              }\n\n              &.pending {\n                background: #fff3cd;\n                color: #ffc107;\n              }\n\n              &.part-payment {\n                background: #e7f3ff;\n                color: #0066cc;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .item-list-square {\n      margin: 0;\n      padding-left: 16px;\n\n      li {\n        margin-bottom: 4px;\n        font-size: 13px;\n        color: #6c757d;\n      }\n    }\n\n    button {\n      // height: 1.5rem;\n      margin-right: 6px;\n      padding: 8px 18px;\n      font-size: 12px;\n      border: none;\n      border-radius: 4px;\n      cursor: pointer;\n      font-weight: 500;\n      transition: all 0.2s ease;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      &:first-child {\n        background: #17a2b8;\n        color: white;\n\n        &:hover {\n          background: #138496;\n          opacity: 0.9;\n        }\n      }\n\n      &:nth-child(2) {\n        background: #6c757d;\n        color: white;\n\n        &:hover {\n          background: #6c757d;\n        }\n      }\n\n      &:last-child {\n        background: #28a745;\n        color: white;\n\n        &:hover {\n          background: #218838;\n        }\n      }\n\n      &:disabled {\n        background: #e9ecef !important;\n        color: #6c757d !important;\n        cursor: not-allowed !important;\n      }\n    }\n\n    .preview-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n    }\n  }\n.invoice-card .header input[type=\"checkbox\"] {\n  margin-left: auto;\n  margin-right: 8px; /* Adjust for rightmost positioning */\n}\n\n\n  // Send Email Modal Styles\n  .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    animation: fadeIn 0.2s ease;\n\n    .send-email-modal {\n      background: #ffffff;\n      border-radius: 12px;\n      padding: 0;\n      width: 90%;\n      max-width: 500px;\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n      animation: scaleIn 0.2s ease;\n\n      .modal-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 1.5rem;\n        border-bottom: 1px solid #e9ecef;\n\n        h3 {\n          margin: 0;\n          font-size: 20px;\n          color: #2c3e50;\n          font-weight: 600;\n        }\n\n        .close-btn {\n          background: none;\n          border: none;\n          font-size: 24px;\n          color: #6c757d;\n          cursor: pointer;\n          padding: 0;\n          width: 30px;\n          height: 30px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 50%;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background: #f8f9fa;\n            color: #495057;\n          }\n        }\n      }\n\n      .modal-body {\n        padding: 1.5rem;\n\n        p {\n          margin: 0 0 1.5rem 0;\n          color: #6c757d;\n          font-size: 16px;\n        }\n\n        .status-options {\n          display: grid;\n          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n          gap: 12px;\n\n          .status-option-btn {\n            padding: 12px 16px;\n            border: none;\n            border-radius: 8px;\n            font-weight: 600;\n            font-size: 14px;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n\n            &:hover {\n              transform: translateY(-2px);\n              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n            }\n\n            &.paid {\n              background: #e8f5e8;\n              color: #28a745;\n              border: 2px solid #28a745;\n\n              &:hover {\n                background: #28a745;\n                color: white;\n              }\n            }\n\n            &.cancelled {\n              background: #ffe6e6;\n              color: #dc3545;\n              border: 2px solid #dc3545;\n\n              &:hover {\n                background: #dc3545;\n                color: white;\n              }\n            }\n\n            &.pending {\n              background: #fff3cd;\n              color: #ffc107;\n              border: 2px solid #ffc107;\n\n              &:hover {\n                background: #ffc107;\n                color: white;\n              }\n            }\n\n            &.part-payment {\n              background: #e7f3ff;\n              color: #0066cc;\n              border: 2px solid #0066cc;\n\n              &:hover {\n                background: #0066cc;\n                color: white;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Loading state\n  .loader {\n    text-align: center;\n    padding: 3rem;\n    color: #6c757d;\n    font-size: 16px;\n\n    &::after {\n      content: '';\n      display: inline-block;\n      width: 20px;\n      height: 20px;\n      border: 2px solid #f3f3f3;\n      border-top: 2px solid var(--primary-color);\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n      margin-left: 10px;\n    }\n  }\n\n  // Responsive design\n  @media (max-width: 768px) {\n    padding: 1rem;\n\n    .invoices-header {\n      flex-direction: column;\n      gap: 1rem;\n\n      .view-toggle-wrapper {\n        order: 2;\n        align-self: flex-start;\n      }\n\n      .header-buttons {\n        order: 1;\n        align-self: flex-end;\n        flex-direction: column;\n        width: 100%;\n\n        .send-email-btn,\n        .filter-toggle-btn {\n          width: 100%;\n        }\n\n        .filter-dropdown-wrapper {\n          .filter-dropdown-box {\n            width: 280px;\n            right: 0;\n            left: auto;\n          }\n        }\n      }\n    }\n\n    .invoice-grid {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n    }\n\n    .invoice-card {\n      padding: 1rem;\n\n      .header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.5rem;\n\n        .status {\n          align-self: flex-end;\n        }\n      }\n\n      .items .item {\n        grid-template-columns: 1fr;\n        gap: 0.25rem;\n        text-align: left;\n\n        div:nth-child(2),\n        div:last-child {\n          text-align: left;\n        }\n      }\n    }\n\n    .invoice-table {\n      font-size: 13px;\n      // ADDED: Less margin on mobile\n      margin-bottom: 60px;\n\n      thead th,\n      tbody td {\n        padding: 8px;\n      }\n    }\n\n    h2 {\n      font-size: 24px;\n    }\n\n    .modal-overlay {\n      .send-email-modal {\n        width: 95%;\n        margin: 1rem;\n\n        .modal-body {\n          .status-options {\n            grid-template-columns: 1fr 1fr;\n            gap: 8px;\n\n            .status-option-btn {\n              padding: 10px 12px;\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Amount dropdown styles\n.amount-dropdown {\n  position: relative;\n  cursor: pointer;\n\n  .amount-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 12px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n    transition: all 0.2s ease;\n\n    strong {\n      color: #495057;\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    .dropdown-arrow {\n      font-size: 10px;\n      color: #6c757d;\n      transition: transform 0.2s ease;\n    }\n  }\n\n  .amount-details {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-5px);\n    transition: all 0.2s ease;\n    margin-top: 2px;\n\n    .amount-row {\n      display: flex;\n      justify-content: space-between;\n      padding: 8px 12px;\n      font-size: 13px;\n      border-bottom: 1px solid #f1f3f4;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      &.pending {\n        background: #fff3cd;\n        color: #856404;\n        font-weight: 600;\n      }\n\n      span:first-child {\n        color: #6c757d;\n      }\n\n      span:last-child {\n        font-weight: 600;\n        color: #495057;\n      }\n    }\n  }\n\n  &:hover {\n    .amount-header {\n      background: #e9ecef;\n      border-color: #dee2e6;\n\n      .dropdown-arrow {\n        transform: rotate(180deg);\n      }\n    }\n\n    .amount-details {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n    }\n  }\n}\n\n// Table specific dropdown styles\n.table-dropdown {\n  .amount-header {\n    background: transparent;\n    border: none;\n    padding: 4px 8px;\n    border-radius: 4px;\n\n    &:hover {\n      background: #f8f9fa;\n    }\n\n    span:first-child {\n      font-weight: 600;\n      color: #495057;\n    }\n  }\n\n  .amount-details {\n    min-width: 150px;\n    left: -20px;\n  }\n}\n\n// Mobile responsive for dropdown\n@media (max-width: 768px) {\n  .amount-dropdown {\n    .amount-details {\n      position: fixed;\n      left: 10px;\n      right: 10px;\n      top: auto;\n      bottom: 10px;\n      border-radius: 8px;\n      margin: 0;\n    }\n  }\n}\n\n// Animations\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 7px 18px;\n  background-color: #E2E8F0;\n  border-radius: 6px;\n\n\n  label {\n    white-space: nowrap;\n    color: #1f2937;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n\n  #invoicePerPageSelect {\n    border: none;\n    border-radius: 6px;\n    outline: none;\n    padding: 6px 32px 6px 12px;\n    background-color: white;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n    min-width: 70px;\n\n\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n\n\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 16px;\n\n\n    transition: all 0.2s ease;\n    box-shadow: none !important;\n\n\n    &:hover {\n      background-color: #fafafa;\n    }\n\n\n    &:focus {\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n      background-color: white;\n    }\n\n\n    option {\n      border: none !important;\n      outline: none;\n      padding: 4px 8px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
